import { Injectable } from '@angular/core';

@Injectable()
export class ClickCounterService {
  private counter = 0;

  incrementCounter() {
    this.counter++;
  }

  getCounter() {
    return this.counter;
  }
}
